var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiveUsoRacionadoresEscritorio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FBAA19;}\n\t.st1{fill:#FBAA19;stroke:#FFFFFF;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 6.5,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8,
    y: 6.5,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.7,
    y: 6.5,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.3,
    y: 6.5,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29.1,6.5 39.2,6.5 26.4,24 16.6,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82.6,6.5 94.6,6.5 67.8,42.8 67.8,27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.7,25.3 16.6,25.3 29.5,42.8 39.2,42.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "128.7,4.3 123.2,10.9 133.5,24 143.2,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "133.1,25.3 143.2,25.3 128.7,44.1 122.7,38  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.4,
    y: 6.5,
    className: "st0",
    width: 13.9,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.4,
    y: 20.5,
    className: "st0",
    width: 8.4,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.4,
    y: 34.9,
    className: "st0",
    width: 13.9,
    height: 7.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,20c0.7,0.7,1.7,1.1,3,1.1c1.3,0,2.2-0.4,3-1.1c0.7-0.7,1.1-1.7,1.1-2.9V7.8h3.2v9.3 c0,1.4-0.3,2.6-0.9,3.6c-0.6,1-1.4,1.8-2.5,2.3c-1.1,0.5-2.4,0.8-3.8,0.8c-1.5,0-2.8-0.3-3.9-0.8s-1.9-1.3-2.5-2.3 c-0.6-1-0.9-2.2-0.9-3.6V7.8h3.2v9.3C159,18.4,159.3,19.3,160.1,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.9,10.7c-0.9-0.3-1.7-0.4-2.4-0.4c-0.8,0-1.4,0.1-1.8,0.4c-0.4,0.3-0.7,0.6-0.7,1.1c0,0.4,0.2,0.8,0.5,1.1 c0.3,0.3,0.7,0.5,1.2,0.7c0.5,0.2,1.1,0.4,1.9,0.6c1.1,0.3,2.1,0.6,2.8,1c0.7,0.3,1.3,0.8,1.8,1.4s0.8,1.4,0.8,2.4 c0,1-0.3,1.8-0.8,2.5s-1.3,1.3-2.3,1.6c-1,0.4-2.1,0.6-3.3,0.6c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.1-3.2-1.8l1.3-2.6 c0.8,0.7,1.8,1.3,2.8,1.7s2,0.6,2.9,0.6c0.9,0,1.6-0.2,2.1-0.5c0.5-0.3,0.8-0.8,0.8-1.3c0-0.5-0.2-0.8-0.5-1.1 c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.2-1.1-0.4-2-0.6c-1.1-0.3-2-0.6-2.8-0.9c-0.7-0.3-1.3-0.8-1.8-1.4c-0.5-0.6-0.8-1.4-0.8-2.4 c0-0.9,0.3-1.7,0.8-2.4c0.5-0.7,1.2-1.2,2.2-1.6c0.9-0.4,2-0.6,3.3-0.6c1.1,0,2.1,0.2,3.2,0.5c1.1,0.3,2,0.7,2.8,1.2l-1.3,2.7 C183.7,11.3,182.8,11,181.9,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.1,8.6c1.4,0.7,2.4,1.7,3.2,2.9s1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9s2.9-1.1,4.5-1.1C198.3,7.6,199.8,7.9,201.1,8.6z M193.8,11c-0.9,0.5-1.6,1.1-2.1,1.9 c-0.5,0.8-0.8,1.7-0.8,2.7s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2 s0.8-1.7,0.8-2.7s-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9s-1.8-0.7-2.8-0.7C195.6,10.3,194.7,10.5,193.8,11z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.1,10.8c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7c-0.9,0.5-1.5,1.1-2,1.9c-0.5,0.8-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7c0.5,0.8,1.2,1.5,2,1.9s1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5s1.5-0.8,2.1-1.4l1.9,2c-0.9,0.8-1.9,1.5-3,2 c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.4-1.7-3.1-3c-0.8-1.2-1.1-2.6-1.1-4.1s0.4-2.9,1.2-4.1 s1.8-2.2,3.2-2.9c1.3-0.7,2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7c1.1,0.5,2.1,1.1,2.9,1.9l-1.9,2.2 C225.6,11.7,224.9,11.2,224.1,10.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.4,8.6c1.4,0.7,2.4,1.7,3.2,2.9s1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1s-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9c1.4-0.7,2.9-1.1,4.5-1.1S241.1,7.9,242.4,8.6z M235.1,11c-0.9,0.5-1.6,1.1-2.1,1.9s-0.8,1.7-0.8,2.7 s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2s0.8-1.7,0.8-2.7 s-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9s-1.8-0.7-2.8-0.7C236.9,10.3,236,10.5,235.1,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.6,7.8h3.6l5.5,10.2l5.5-10.2h3.6v15.9H265V12.2l-5.2,9.7h-2l-5.2-9.7v11.4h-2.9V7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272,7.8h12.2v2.7h-9v3.9h8.1V17h-8.1v4h9.3v2.7H272V7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.1,23.6l-2.9-4.7c-0.1,0-0.3,0-0.6,0h-3.8v4.7h-3.2V7.8h7c2.2,0,3.8,0.5,5,1.4c1.2,1,1.8,2.3,1.8,4 c0,1.2-0.3,2.3-0.8,3.2c-0.6,0.9-1.4,1.5-2.5,2l3.7,5.3H298.1z M290.9,16.3h3.8c1.2,0,2.1-0.2,2.8-0.7c0.6-0.5,1-1.2,1-2.2 c0-1-0.3-1.7-1-2.2c-0.6-0.5-1.6-0.7-2.8-0.7h-3.8V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.9,10.8c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7c-0.9,0.5-1.5,1.1-2,1.9c-0.5,0.8-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7c0.5,0.8,1.2,1.5,2,1.9s1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5s1.5-0.8,2.1-1.4l1.9,2c-0.9,0.8-1.9,1.5-3,2 c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.4-1.7-3.1-3c-0.8-1.2-1.1-2.6-1.1-4.1s0.4-2.9,1.2-4.1 s1.8-2.2,3.2-2.9c1.3-0.7,2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7c1.1,0.5,2.1,1.1,2.9,1.9l-1.9,2.2 C316.4,11.7,315.7,11.2,314.9,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.5,7.8h3.2v15.9h-3.2V7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.1,23.6l-1.5-3.4h-8.1l-1.5,3.4h-3.3L334,7.8h3.3l7.2,15.9H341.1z M332.6,17.7h5.9l-2.9-6.7L332.6,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.6,7.8h3.2v13.1h7.2v2.7h-10.4V7.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.5,29.9l-6.1,10.7v5.2h-3.2v-5.1L154,29.9h3.2l4.5,7.5l4.5-7.5H169.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,30.9c1.3,0.7,2.3,1.6,3.1,2.8c0.7,1.2,1.1,2.6,1.1,4.1c0,1.5-0.4,2.9-1.1,4.1c-0.8,1.2-1.8,2.1-3.1,2.8 s-2.8,1-4.5,1h-6.8V29.9h6.9C186,29.9,187.4,30.2,188.8,30.9z M187.1,42.4c0.8-0.4,1.5-1.1,1.9-1.9c0.5-0.8,0.7-1.7,0.7-2.7 s-0.2-1.9-0.7-2.7c-0.5-0.8-1.1-1.4-2-1.9s-1.8-0.7-2.8-0.7h-3.7v10.5h3.8C185.4,43.1,186.3,42.8,187.1,42.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.3,30.7c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1c0,1.5-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1c0-1.5,0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9s2.9-1.1,4.5-1.1C204.4,29.7,205.9,30,207.3,30.7z M200,33.1c-0.9,0.5-1.6,1.1-2.1,1.9 c-0.5,0.8-0.8,1.7-0.8,2.7c0,1,0.3,1.9,0.8,2.7c0.5,0.8,1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7 c0.9-0.5,1.5-1.1,2-2c0.5-0.8,0.8-1.7,0.8-2.7c0-1-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9c-0.9-0.5-1.8-0.7-2.8-0.7 C201.8,32.4,200.8,32.6,200,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,29.9h3.6l5.5,10.2l5.5-10.2h3.6v15.9h-2.9V34.3l-5.2,9.7h-2l-5.2-9.7v11.4h-2.9V29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.8,29.9H249v2.7h-9v3.9h8.1v2.7H240v4h9.3v2.7h-12.5V29.9z M244,25.1l3,1.2l-3,2.3l-2.4-0.2L244,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.4,32.8c-0.9-0.3-1.7-0.4-2.4-0.4c-0.8,0-1.4,0.1-1.8,0.4c-0.4,0.3-0.7,0.7-0.7,1.1c0,0.4,0.2,0.8,0.5,1.1 c0.3,0.3,0.7,0.5,1.2,0.7s1.1,0.4,1.9,0.6c1.1,0.3,2.1,0.6,2.8,1s1.3,0.8,1.8,1.4c0.5,0.6,0.8,1.4,0.8,2.4c0,1-0.3,1.8-0.8,2.5 s-1.3,1.3-2.3,1.6c-1,0.4-2.1,0.6-3.3,0.6c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.1-3.2-1.8l1.3-2.6c0.8,0.7,1.8,1.3,2.8,1.7 c1,0.4,2,0.6,2.9,0.6c0.9,0,1.6-0.2,2.1-0.5c0.5-0.3,0.8-0.8,0.8-1.3c0-0.5-0.2-0.8-0.5-1.1s-0.7-0.5-1.2-0.7 c-0.5-0.2-1.1-0.4-2-0.6c-1.1-0.3-2-0.6-2.8-0.9c-0.7-0.3-1.3-0.8-1.8-1.4c-0.5-0.6-0.8-1.4-0.8-2.4c0-0.9,0.3-1.7,0.8-2.4 c0.5-0.7,1.2-1.2,2.2-1.6c0.9-0.4,2-0.6,3.3-0.6c1.1,0,2.1,0.2,3.2,0.5c1.1,0.3,2,0.7,2.8,1.2l-1.3,2.7 C262.2,33.4,261.3,33.1,260.4,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.6,29.9h13.6v2.7H274v13.2h-3.2V32.6h-5.2V29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.5,29.9h3.2v15.9h-3.2V29.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.8,32.9c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7s-1.5,1.1-2,1.9s-0.7,1.7-0.7,2.7s0.2,1.9,0.7,2.7 s1.2,1.5,2,2c0.9,0.5,1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5s1.5-0.8,2.1-1.4l1.9,2c-0.9,0.8-1.9,1.5-3,2c-1.2,0.5-2.3,0.7-3.5,0.7 c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.4-1.7-3.1-3c-0.8-1.2-1.1-2.6-1.1-4.1c0-1.5,0.4-2.9,1.2-4.1c0.8-1.2,1.8-2.2,3.2-2.9 c1.3-0.7,2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7c1.1,0.5,2.1,1.1,2.9,1.9l-1.9,2.2C300.2,33.8,299.6,33.3,298.8,32.9z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.1,30.7c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1c0,1.5-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1c0-1.5,0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9c1.4-0.7,2.9-1.1,4.5-1.1C314.2,29.7,315.7,30,317.1,30.7z M309.8,33.1c-0.9,0.5-1.6,1.1-2.1,1.9 c-0.5,0.8-0.8,1.7-0.8,2.7c0,1,0.3,1.9,0.8,2.7c0.5,0.8,1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7 c0.9-0.5,1.5-1.1,2-2c0.5-0.8,0.8-1.7,0.8-2.7c0-1-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9c-0.9-0.5-1.8-0.7-2.8-0.7 C311.6,32.4,310.7,32.6,309.8,33.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiveUsoRacionadoresEscritorio);
export default __webpack_public_path__ + "static/media/kive-uso-racionadores-escritorio.c489984a8d5e7499def6c9803e8038ba.svg";
export { ForwardRef as ReactComponent };